var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSellingPetra({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.5,
    height: 90.52,
    viewBox: "0 0 97.5 90.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Petra_-_Flaticon-2",
    "data-name": "Search results for Petra - Flaticon-2",
    transform: "translate(-3.45 -9.193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10507",
    "data-name": "Group 10507",
    transform: "translate(3.7 9.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10050",
    "data-name": "Path 10050",
    d: "M56.039,91.575H44.323a.493.493,0,0,1-.523-.523V72.223a.493.493,0,0,1,.523-.523H56.039a.493.493,0,0,1,.523.523V91.051A.56.56,0,0,1,56.039,91.575ZM44.846,90.529H55.515V72.746H44.846Z",
    transform: "translate(-1.89 -6.593)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10051",
    "data-name": "Path 10051",
    d: "M91.427,88.711h-4.7a.493.493,0,0,1-.523-.523V61.723a.493.493,0,0,1,.523-.523h4.7a.493.493,0,0,1,.523.523V88.187a.493.493,0,0,1-.523.524Zm-4.184-1.046H90.9V62.246H87.246Z",
    transform: "translate(0.026 -7.077)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10052",
    "data-name": "Path 10052",
    d: "M92.518,90.888h-6.7a.493.493,0,0,1-.523-.523V87.751A1.161,1.161,0,0,1,86.451,86.6h5.335a1.161,1.161,0,0,1,1.151,1.151v2.615a.69.69,0,0,1-.418.523Zm-6.171-1.046H92V87.751c0-.1,0-.1-.1-.1H86.556a.1.1,0,0,0-.1.1Z",
    transform: "translate(-0.015 -5.908)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10053",
    "data-name": "Path 10053",
    d: "M92.1,62.348H86.242a.938.938,0,0,1-.942-.942V59.523A.493.493,0,0,1,85.823,59h6.7a.493.493,0,0,1,.523.523v1.883a.938.938,0,0,1-.941.942ZM86.346,61.3H92V60.046H86.346Z",
    transform: "translate(-0.015 -7.178)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10054",
    "data-name": "Path 10054",
    d: "M77.327,88.711h-4.7a.493.493,0,0,1-.523-.523V61.723a.493.493,0,0,1,.523-.523h4.7a.493.493,0,0,1,.523.523V88.187a.493.493,0,0,1-.523.524Zm-4.184-1.046H76.8V62.246H73.042Z",
    transform: "translate(-0.608 -7.077)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10055",
    "data-name": "Path 10055",
    d: "M78.313,90.888H71.723a.493.493,0,0,1-.523-.523V87.751A1.161,1.161,0,0,1,72.351,86.6h5.335a1.161,1.161,0,0,1,1.151,1.151v2.615a.56.56,0,0,1-.523.523Zm-6.171-1.046h5.649V87.751c0-.1,0-.1-.1-.1H72.351a.1.1,0,0,0-.1.1Z",
    transform: "translate(-0.649 -5.908)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10056",
    "data-name": "Path 10056",
    d: "M77.9,62.348H72.042a.938.938,0,0,1-.942-.942V59.523A.493.493,0,0,1,71.623,59h6.7a.493.493,0,0,1,.523.523v1.883a.938.938,0,0,1-.941.942ZM72.251,61.3H77.9V60.046H72.251Z",
    transform: "translate(-0.654 -7.178)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10057",
    "data-name": "Path 10057",
    d: "M63.235,88.711H58.423a.493.493,0,0,1-.523-.523V61.723a.493.493,0,0,1,.523-.523h4.812a.493.493,0,0,1,.523.523V88.187a.493.493,0,0,1-.523.524Zm-4.184-1.046h3.661V62.246H58.946Z",
    transform: "translate(-1.25 -7.077)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10058",
    "data-name": "Path 10058",
    d: "M64.218,90.888h-6.7A.493.493,0,0,1,57,90.366V87.751A1.161,1.161,0,0,1,58.151,86.6h5.335a1.161,1.161,0,0,1,1.151,1.151v2.615c.1.209-.209.418-.418.523Zm-6.171-1.046H63.7V87.751c0-.1,0-.1-.1-.1H58.256a.1.1,0,0,0-.1.1v2.092Z",
    transform: "translate(-1.291 -5.908)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10059",
    "data-name": "Path 10059",
    d: "M63.8,62.348H57.942A.938.938,0,0,1,57,61.406V59.523A.493.493,0,0,1,57.523,59h6.7a.493.493,0,0,1,.523.523v1.883a.938.938,0,0,1-.941.942ZM58.046,61.3H63.7V60.046H58.046Z",
    transform: "translate(-1.291 -7.178)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10060",
    "data-name": "Path 10060",
    d: "M41.727,88.711h-4.7a.493.493,0,0,1-.523-.523V61.723a.493.493,0,0,1,.523-.523h4.7a.493.493,0,0,1,.523.523V88.187a.493.493,0,0,1-.523.524Zm-4.184-1.046H41.2V62.246H37.442Z",
    transform: "translate(-2.217 -7.077)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10061",
    "data-name": "Path 10061",
    d: "M42.718,90.888h-6.7a.493.493,0,0,1-.523-.523V87.751A1.161,1.161,0,0,1,36.651,86.6h5.335a1.161,1.161,0,0,1,1.151,1.151v2.615c.1.209-.209.418-.418.523Zm-6.171-1.046H42.2V87.751c0-.1,0-.1-.1-.1H36.756a.1.1,0,0,0-.1.1v2.092Z",
    transform: "translate(-2.263 -5.908)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10062",
    "data-name": "Path 10062",
    d: "M42.3,62.348H36.442a.938.938,0,0,1-.942-.942V59.523A.493.493,0,0,1,36.023,59h6.7a.493.493,0,0,1,.523.523v1.883a.938.938,0,0,1-.941.942ZM36.546,61.3H42.2V60.046H36.546Z",
    transform: "translate(-2.263 -7.178)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10063",
    "data-name": "Path 10063",
    d: "M85.309,80.08H78.823a.493.493,0,0,1-.523-.523V69.934A3.015,3.015,0,0,1,81.229,66.9h1.677a2.885,2.885,0,0,1,2.929,3.034v9.623a.493.493,0,0,1-.527.523Zm-6.067-1.048h5.544v-9.1A2.04,2.04,0,0,0,82.9,67.946H81.226a1.986,1.986,0,0,0-1.987,1.987Z",
    transform: "translate(-0.338 -6.815)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10064",
    "data-name": "Path 10064",
    d: "M21.413,80.08H14.823a.493.493,0,0,1-.523-.523V69.934A3.036,3.036,0,0,1,17.334,66.9h1.677a3.036,3.036,0,0,1,3.034,3.034v9.623a.663.663,0,0,1-.631.523Zm-6.067-1.048h5.544v-9.1a1.967,1.967,0,0,0-1.883-1.987H17.331a1.986,1.986,0,0,0-1.987,1.987Z",
    transform: "translate(-3.212 -6.815)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10065",
    "data-name": "Path 10065",
    d: "M27.527,88.711h-4.7a.493.493,0,0,1-.523-.523V61.723a.493.493,0,0,1,.523-.523h4.7a.493.493,0,0,1,.523.523V88.187a.493.493,0,0,1-.523.524Zm-4.184-1.046H27V62.246H23.346Z",
    transform: "translate(-2.86 -7.077)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10066",
    "data-name": "Path 10066",
    d: "M28.518,90.888h-6.7a.493.493,0,0,1-.523-.523V87.751A1.161,1.161,0,0,1,22.451,86.6h5.335a1.161,1.161,0,0,1,1.151,1.151v2.615c.1.209-.1.523-.418.523Zm-6.067-1.046H28.1V87.751c0-.1,0-.1-.1-.1H22.66a.1.1,0,0,0-.1.1Z",
    transform: "translate(-2.904 -5.908)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10067",
    "data-name": "Path 10067",
    d: "M28.2,62.348H22.342a.938.938,0,0,1-.942-.942V59.523A.493.493,0,0,1,21.923,59h6.7a.493.493,0,0,1,.523.523v1.883a1.1,1.1,0,0,1-.941.942ZM22.446,61.3H28.1V60.046H22.446Z",
    transform: "translate(-2.9 -7.178)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10068",
    "data-name": "Path 10068",
    d: "M13.435,88.711H8.623a.493.493,0,0,1-.523-.523V61.723a.493.493,0,0,1,.523-.523h4.7a.493.493,0,0,1,.523.523V88.187c.1.314-.1.523-.418.523ZM9.251,87.665h3.661V62.246H9.146Z",
    transform: "translate(-3.498 -7.077)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10069",
    "data-name": "Path 10069",
    d: "M14.418,90.888h-6.7a.493.493,0,0,1-.523-.523V87.751A1.161,1.161,0,0,1,8.351,86.6h5.335a1.161,1.161,0,0,1,1.151,1.151v2.615C14.941,90.575,14.731,90.888,14.418,90.888ZM8.246,89.843H13.9V87.751c0-.1,0-.1-.1-.1H8.456a.1.1,0,0,0-.1.1v2.092Z",
    transform: "translate(-3.539 -5.908)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10070",
    "data-name": "Path 10070",
    d: "M14,62.348H8.142a.938.938,0,0,1-.942-.942V59.523A.493.493,0,0,1,7.723,59h6.7a.493.493,0,0,1,.523.523v1.883a.938.938,0,0,1-.942.942ZM8.246,61.3H13.9V60.046H8.246Z",
    transform: "translate(-3.539 -7.178)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10071",
    "data-name": "Path 10071",
    d: "M90.534,49.463H69.822a.493.493,0,0,1-.523-.523V28.123a.493.493,0,0,1,.523-.523H90.639a.493.493,0,0,1,.523.523V48.939a.663.663,0,0,1-.627.523ZM70.346,48.416h19.77V28.646H70.346Z",
    transform: "translate(-0.752 -8.624)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10072",
    "data-name": "Path 10072",
    d: "M74.938,47.715H72.323a.493.493,0,0,1-.523-.523V29.723a.493.493,0,0,1,.523-.523h2.615a.493.493,0,0,1,.523.523v17.47a.56.56,0,0,1-.522.523Zm-2.092-1.046h1.569V30.246H72.951Z",
    transform: "translate(-0.62 -8.551)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10073",
    "data-name": "Path 10073",
    d: "M75.066,30.319H72.136a.826.826,0,0,1-.836-.836v-1.36a.493.493,0,0,1,.523-.523h3.661a.493.493,0,0,1,.523.523v1.36a.922.922,0,0,1-.942.836Zm-2.719-1.043h2.615v-.627H72.346Z",
    transform: "translate(-0.643 -8.624)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10074",
    "data-name": "Path 10074",
    d: "M87.438,47.715H84.823a.493.493,0,0,1-.523-.523V29.723a.493.493,0,0,1,.523-.523h2.615a.493.493,0,0,1,.523.523v17.47a.493.493,0,0,1-.522.523Zm-2.092-1.046h1.569V30.246H85.346Z",
    transform: "translate(-0.062 -8.551)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10075",
    "data-name": "Path 10075",
    d: "M87.666,30.319H84.736a.826.826,0,0,1-.836-.836v-1.36a.493.493,0,0,1,.523-.523h3.557a.493.493,0,0,1,.523.523v1.36a.9.9,0,0,1-.836.836Zm-2.824-1.043h2.51v-.627H84.736Z",
    transform: "translate(-0.08 -8.624)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10076",
    "data-name": "Path 10076",
    d: "M91.294,22.682H70.269A1.609,1.609,0,0,1,68.7,21.113V11.071a1.788,1.788,0,0,1,.732-1.36,1.479,1.479,0,0,1,1.465-.1L92.027,19.649a1.578,1.578,0,0,1,.836,2.092A1.8,1.8,0,0,1,91.294,22.682ZM70.269,10.55a.385.385,0,0,0-.314.1.543.543,0,0,0-.209.418v9.936a.493.493,0,0,0,.523.523H91.294a.493.493,0,0,0,.523-.523.575.575,0,0,0-.314-.523L70.377,10.548c0,.1,0,0-.108,0ZM86.692,20.59H71.315a.493.493,0,0,1-.523-.523V12.744A.543.543,0,0,1,71,12.326a.467.467,0,0,1,.523,0L86.9,19.649a.632.632,0,0,1,.314.627A.888.888,0,0,1,86.692,20.59ZM71.838,19.543H84.39L71.838,13.582Z",
    transform: "translate(-0.78 -9.46)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10077",
    "data-name": "Path 10077",
    d: "M90.258,28.945H70.069A1.609,1.609,0,0,1,68.5,27.376V22.669A1.609,1.609,0,0,1,70.069,21.1H90.258a1.609,1.609,0,0,1,1.569,1.569v4.708a1.541,1.541,0,0,1-1.569,1.568Zm-20.189-6.8a.493.493,0,0,0-.523.523v4.708a.493.493,0,0,0,.523.523H90.258a.493.493,0,0,0,.523-.523V22.669a.493.493,0,0,0-.523-.523Z",
    transform: "translate(-0.79 -8.924)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10078",
    "data-name": "Path 10078",
    d: "M75.484,48.619H71.823A.493.493,0,0,1,71.3,48.1v-1.36a.826.826,0,0,1,.836-.836h2.929a.826.826,0,0,1,.836.836V48.1C76.007,48.41,75.8,48.619,75.484,48.619Zm-3.137-1.043h2.615v-.732h-2.51Z",
    transform: "translate(-0.643 -7.782)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10079",
    "data-name": "Path 10079",
    d: "M87.984,48.619H84.323A.493.493,0,0,1,83.8,48.1v-1.36a.826.826,0,0,1,.836-.836h2.929a.826.826,0,0,1,.836.836V48.1C88.508,48.41,88.3,48.619,87.984,48.619Zm-3.137-1.043h2.51v-.732h-2.51Z",
    transform: "translate(-0.085 -7.782)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10080",
    "data-name": "Path 10080",
    d: "M31.039,49.463H10.223A.493.493,0,0,1,9.7,48.94V28.123a.493.493,0,0,1,.523-.523H31.039a.493.493,0,0,1,.523.523V48.939a.493.493,0,0,1-.523.524ZM10.746,48.416h19.77V28.646H10.746Z",
    transform: "translate(-3.424 -8.624)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10081",
    "data-name": "Path 10081",
    d: "M99.086,53.671H5.222a.493.493,0,0,1-.522-.523V48.02a.493.493,0,0,1,.522-.523H36.366a.523.523,0,0,1,0,1.046H5.746v4.085H98.562V48.546H67.833a.523.523,0,0,1,0-1.046H99.086a.493.493,0,0,1,.522.523v5.129a.493.493,0,0,1-.522.52Z",
    transform: "translate(-3.654 -7.708)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10082",
    "data-name": "Path 10082",
    d: "M57.638,44.377a.493.493,0,0,1-.523-.523V30.045H55.546V42.177a.523.523,0,1,1-1.046,0V29.523A.493.493,0,0,1,55.023,29h2.615a.493.493,0,0,1,.523.523V43.854a.56.56,0,0,1-.523.523Z",
    transform: "translate(-1.403 -8.56)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10083",
    "data-name": "Path 10083",
    d: "M57.866,30.143H54.936a.826.826,0,0,1-.836-.836V27.423a.523.523,0,1,1,1.046,0V29.1h2.615V27.842a.523.523,0,0,1,1.046,0v1.465A1.006,1.006,0,0,1,57.866,30.143Z",
    transform: "translate(-1.421 -8.656)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10084",
    "data-name": "Path 10084",
    d: "M42.523,44.377A.493.493,0,0,1,42,43.854V29.523A.493.493,0,0,1,42.523,29h2.615a.493.493,0,0,1,.523.523V42.18a.523.523,0,1,1-1.046,0V30.048H43.046V43.857a.493.493,0,0,1-.523.523Z",
    transform: "translate(-1.968 -8.56)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10085",
    "data-name": "Path 10085",
    d: "M45.366,30.143H42.436a.826.826,0,0,1-.836-.836v-1.57a.523.523,0,1,1,1.046,0V29.1h2.51V27.42a.523.523,0,1,1,1.046,0V29.3a.9.9,0,0,1-.836.836Z",
    transform: "translate(-1.986 -8.656)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10086",
    "data-name": "Path 10086",
    d: "M27.638,47.715H25.023a.493.493,0,0,1-.523-.523V29.723a.493.493,0,0,1,.523-.523h2.615a.493.493,0,0,1,.523.523v17.47A.56.56,0,0,1,27.638,47.715Zm-2.092-1.046h1.569V30.246H25.651Z",
    transform: "translate(-2.759 -8.551)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10087",
    "data-name": "Path 10087",
    d: "M27.866,30.319H24.936a.826.826,0,0,1-.836-.836v-1.36a.493.493,0,0,1,.523-.523h3.557a.493.493,0,0,1,.523.523v1.36a.826.826,0,0,1-.836.836Zm-2.719-1.043h2.615v-.627h-2.51Z",
    transform: "translate(-2.778 -8.624)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10088",
    "data-name": "Path 10088",
    d: "M15.134,47.715H12.623a.493.493,0,0,1-.523-.523V29.723a.493.493,0,0,1,.523-.523h2.51a.493.493,0,0,1,.523.523v17.47A.56.56,0,0,1,15.134,47.715Zm-1.987-1.046h1.465V30.246H13.146Z",
    transform: "translate(-3.313 -8.551)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10089",
    "data-name": "Path 10089",
    d: "M28.179,48.619H24.623A.493.493,0,0,1,24.1,48.1v-1.36a.826.826,0,0,1,.836-.836h2.929a.826.826,0,0,1,.836.836V48.1a.493.493,0,0,1-.523.523Zm-3.137-1.043h2.615v-.732h-2.51Z",
    transform: "translate(-2.778 -7.782)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10090",
    "data-name": "Path 10090",
    d: "M15.679,48.619H12.123A.493.493,0,0,1,11.6,48.1v-1.36a.826.826,0,0,1,.836-.836h2.929a.826.826,0,0,1,.836.836V48.1a.493.493,0,0,1-.523.523Zm-3.033-1.043h2.51v-.732h-2.51Z",
    transform: "translate(-3.337 -7.782)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10091",
    "data-name": "Path 10091",
    d: "M15.366,30.319H12.436a.826.826,0,0,1-.836-.836v-1.36a.493.493,0,0,1,.523-.523h3.557a.493.493,0,0,1,.523.523v1.36a.9.9,0,0,1-.836.836Zm-2.719-1.043h2.51v-.627h-2.51Z",
    transform: "translate(-3.337 -8.624)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10092",
    "data-name": "Path 10092",
    d: "M96.4,48.546H65.123a.523.523,0,0,1,0-1.046H96.4a.523.523,0,1,1,0,1.046Z",
    transform: "translate(-0.969 -7.708)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10093",
    "data-name": "Path 10093",
    d: "M36.4,48.546H5.223a.523.523,0,0,1,0-1.046H36.39a.523.523,0,1,1,0,1.046Z",
    transform: "translate(-3.654 -7.708)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10094",
    "data-name": "Path 10094",
    d: "M99.086,60.258H5.222a.493.493,0,0,1-.522-.523V54.923a.493.493,0,0,1,.522-.523H99.085a.493.493,0,0,1,.522.523v4.812a.493.493,0,0,1-.521.523ZM5.746,59.212H98.562V55.446H5.746Z",
    transform: "translate(-3.654 -7.39)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10095",
    "data-name": "Path 10095",
    d: "M99.086,95.767H5.222a.493.493,0,0,1-.522-.523V90.223a.493.493,0,0,1,.522-.523H99.085a.493.493,0,0,1,.522.523v5.021a.493.493,0,0,1-.521.523ZM5.746,94.721H98.562V90.746H5.746Z",
    transform: "translate(-3.654 -5.765)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10096",
    "data-name": "Path 10096",
    d: "M99.086,90.746H5.222a.523.523,0,0,1,0-1.046H99.085a.493.493,0,0,1,.522.523C99.609,90.432,99.4,90.642,99.086,90.746Z",
    transform: "translate(-3.654 -5.765)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10097",
    "data-name": "Path 10097",
    d: "M99.132,55.538H5.268a1.569,1.569,0,0,1,0-3.138H99.132a1.569,1.569,0,0,1,0,3.138ZM5.268,53.446a.523.523,0,0,0,0,1.046H99.132a.523.523,0,0,0,0-1.046Z",
    transform: "translate(-3.7 -7.482)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10098",
    "data-name": "Path 10098",
    d: "M71.14,54.106H30.868A1.479,1.479,0,0,1,29.4,52.954a1.7,1.7,0,0,1,.627-1.775L50.219,38.311a1.606,1.606,0,0,1,1.677,0L71.977,51.177a1.649,1.649,0,0,1,.523,2.2,1.788,1.788,0,0,1-1.36.732ZM51.056,39.147a.385.385,0,0,0-.314.1L30.553,52.118a.5.5,0,0,0-.209.627.69.69,0,0,0,.523.418H71.14a.69.69,0,0,0,.523-.418.5.5,0,0,0-.209-.627L51.266,39.252c0-.1-.1-.1-.209-.1ZM67.479,52.014H34.424A.534.534,0,0,1,33.9,51.6c-.1-.209,0-.418.209-.627L50.638,40.4a.467.467,0,0,1,.523,0L67.688,50.967a.466.466,0,0,1,.209.627.383.383,0,0,1-.418.419ZM36.3,50.967H65.7l-14.64-9.415Z",
    transform: "translate(-2.556 -8.142)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10099",
    "data-name": "Path 10099",
    d: "M30.7,22.679H9.569A1.609,1.609,0,0,1,8,21.109a1.4,1.4,0,0,1,.836-1.36L29.967,9.708a1.536,1.536,0,0,1,2.092.732,1.327,1.327,0,0,1,.1.627V21A1.545,1.545,0,0,1,30.7,22.679Zm0-12.132c-.1,0-.209,0-.209.1L9.36,20.586a.5.5,0,0,0-.209.732.56.56,0,0,0,.418.314H30.7a.493.493,0,0,0,.523-.523V11.067c-.1-.314-.314-.523-.523-.523ZM29.653,20.586H14.276a.69.69,0,0,1-.523-.418c-.1-.209.1-.523.314-.627l15.377-7.322a.467.467,0,0,1,.523,0,.543.543,0,0,1,.209.418v7.319A.586.586,0,0,1,29.653,20.586ZM16.581,19.54H29.13V13.578Z",
    transform: "translate(-3.502 -9.456)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10100",
    "data-name": "Path 10100",
    d: "M30.758,28.945H10.569A1.609,1.609,0,0,1,9,27.376V22.669A1.609,1.609,0,0,1,10.569,21.1H30.758a1.609,1.609,0,0,1,1.569,1.569v4.708A1.609,1.609,0,0,1,30.758,28.945Zm-20.189-6.8a.493.493,0,0,0-.523.523v4.708a.493.493,0,0,0,.523.523H30.758a.493.493,0,0,0,.523-.523V22.669a.493.493,0,0,0-.523-.523Z",
    transform: "translate(-3.456 -8.924)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10101",
    "data-name": "Path 10101",
    d: "M60.321,28.9h-.208a60.707,60.707,0,0,0-19.456,0,1.076,1.076,0,0,1-1.256-.732v-6.9c0-.209.209-.523.418-.523a60.341,60.341,0,0,1,21.234,0,.478.478,0,0,1,.418.523V27.75A1.161,1.161,0,0,1,60.321,28.9ZM50.279,27.018a65.037,65.037,0,0,1,10.042.836l.1-6.171a58.251,58.251,0,0,0-19.98,0V27.75a62.23,62.23,0,0,1,9.834-.732Z",
    transform: "translate(-2.093 -8.983)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10102",
    "data-name": "Path 10102",
    d: "M51.9,21.029a1.053,1.053,0,0,1-.314-.1c-.1-.1-.1-.1-.1-.209l-.632-2.41v-.314l.523-1.046H48.763l.523,1.151v.314l-.627,2.3c0,.209-.314.418-.523.418a.493.493,0,0,1-.523-.523v-.1l.523-2.2L47.4,16.629a.467.467,0,0,1,0-.523.789.789,0,0,1,.418-.209h4.288a.543.543,0,0,1,.418.209.467.467,0,0,1,0,.523L51.8,18.306l.523,2.2a.46.46,0,0,1-.1.523H51.9Z",
    transform: "translate(-1.727 -9.163)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10103",
    "data-name": "Path 10103",
    d: "M51.238,16.943a.385.385,0,0,1-.314-.1.6.6,0,0,1-.209-.732.789.789,0,0,0,.1-.523.826.826,0,0,0-.836-.836.9.9,0,0,0-.836.836.629.629,0,0,0,.1.418.523.523,0,1,1-.836.627,1.767,1.767,0,0,1-.314-1.046,1.883,1.883,0,1,1,3.766,0,1.767,1.767,0,0,1-.316,1.046A.334.334,0,0,1,51.238,16.943Z",
    transform: "translate(-1.692 -9.265)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10104",
    "data-name": "Path 10104",
    d: "M82.991,42.839H76.923a.493.493,0,0,1-.523-.523v-8.68A3.036,3.036,0,0,1,79.434,30.6h1.151a3.036,3.036,0,0,1,3.034,3.034v8.68C83.513,42.633,83.3,42.944,82.991,42.839Zm-5.544-1.046h5.021V33.634a1.986,1.986,0,0,0-1.987-1.987H79.329a1.986,1.986,0,0,0-1.987,1.987v8.159Z",
    transform: "translate(-0.425 -8.486)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10105",
    "data-name": "Path 10105",
    d: "M83.441,44.119H76.432a.715.715,0,0,1-.732-.732V42.132a.715.715,0,0,1,.732-.732h7.009a.715.715,0,0,1,.732.732v1.256C84.281,43.806,83.859,44.119,83.441,44.119Zm-6.694-1.043h6.38v-.732h-6.38Z",
    transform: "translate(-0.458 -7.989)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10106",
    "data-name": "Path 10106",
    d: "M23.285,42.939H17.323a.493.493,0,0,1-.523-.523v-8.68A3.036,3.036,0,0,1,19.834,30.7h1.151a3.036,3.036,0,0,1,3.034,3.034v8.68c-.209.314-.418.523-.732.523Zm-5.544-1.046h5.021V33.734a1.967,1.967,0,0,0-1.883-1.987H19.834a1.967,1.967,0,0,0-1.987,1.883Z",
    transform: "translate(-3.097 -8.481)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10107",
    "data-name": "Path 10107",
    d: "M23.841,44.219H16.832a.715.715,0,0,1-.732-.732V42.232a.715.715,0,0,1,.732-.732h7.009a.715.715,0,0,1,.732.732v1.256A.789.789,0,0,1,23.841,44.219Zm-6.694-1.043h6.38v-.732h-6.38Z",
    transform: "translate(-3.129 -7.984)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10108",
    "data-name": "Path 10108",
    d: "M86.18,81.743H78.023a.493.493,0,0,1-.523-.523v-2.2a.493.493,0,0,1,.523-.523H86.18a.493.493,0,0,1,.523.523v2.092A.663.663,0,0,1,86.18,81.743ZM78.544,80.7h7.113V79.651h-7.11Z",
    transform: "translate(-0.375 -6.281)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10109",
    "data-name": "Path 10109",
    d: "M21.968,81.738H14.332a.715.715,0,0,1-.732-.732V79.33a.715.715,0,0,1,.732-.732h7.636a.715.715,0,0,1,.732.732v1.677C22.805,81.319,22.387,81.738,21.968,81.738Zm-7.322-1.046h7.113V79.646H14.646Z",
    transform: "translate(-3.244 -6.276)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10508",
    "data-name": "Group 10508",
    transform: "translate(32.548 22.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10110",
    "data-name": "Path 10110",
    d: "M0,0H8.473V1.046H0Z",
    transform: "matrix(1, -0.004, 0.004, 1, 0, 0.034)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10509",
    "data-name": "Group 10509",
    transform: "translate(63.013 22.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10111",
    "data-name": "Path 10111",
    d: "M0,0H1.046V8.368H0Z",
    transform: "matrix(0.004, -1, 1, 0.004, 0, 1.046)",
    fill: "#00641f",
    stroke: "#00641f",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellingPetra);
export default __webpack_public_path__ + "static/media/sellingPetra.69ee2de01306122be726cafe66f34850.svg";
export { ForwardRef as ReactComponent };